module.exports = __webpack_public_path__ + "media/images/flags/64/Dominican-Republic-de419b8df1a003928565a725b99800fe.png";